import { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';
import { useQuery } from '@apollo/client';
import ModalUtils from 'utils/ModalUtils';
import { FetchPolicy } from 'utils/enum/Core';
import PayrollSettingsQuery from 'services/graphQL/query/payroll/Settings';

const useCustomTaxFields = ({ lotName }) => {
    const [state, setState] = useState({
        userTax: '',
        stateTax: '',
        userTaxName: '',
        customTaxBankAccount: 0,
    });
    const {
        data, loading, error,
    } = useQuery(PayrollSettingsQuery.GET_PAYROLL_CUSTOM_TAX_FIELDS, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: FetchPolicy.NETWORK_ONLY,
        variables: {
            lotName,
        },
    });

    useEffect(() => {
        if (error) {
            ModalUtils.errorMessage(error?.graphQLErrors);
            return;
        }

        if (!loading && !isEmpty(data?.getPayrollCustomTaxFields)) {
            const info = data.getPayrollCustomTaxFields;
            setState({
                userTax: info.userTax,
                stateTax: info.stateTax,
                userTaxName: info.userTaxName,
                customTaxBankAccount: info.customTaxBankAccount,
            });
        }
    }, [data, loading, error]);

    return state;
};

export default useCustomTaxFields;
